import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { useDataAttributes } from '@bluebeam/react-hooks';
import { useRef } from 'react';
import { useCheckbox, useFocusRing, VisuallyHidden } from 'react-aria';
import { useToggleState } from 'react-stately';
/**
 * Checkbox is a type of **molecule** shown as a square box that is checked when activated.
 */
const Checkbox = (props) => {
    const ref = useRef(null);
    const { ariaLabel, onChecked, variant, ...otherProps } = props;
    const ariaProps = { ...otherProps, 'aria-label': ariaLabel };
    const isDisabled = props.isDisabled;
    const toggleState = useToggleState({ isSelected: props.isSelected });
    const { inputProps } = useCheckbox(ariaProps, toggleState, ref);
    const { isFocusVisible, focusProps } = useFocusRing();
    const dataAttributes = useDataAttributes(props);
    const getRectColors = () => {
        if (isDisabled) {
            return [
                toggleState.isSelected ? '#5CA1D6' : 'rgba(220, 223, 227, 0.4)',
                toggleState.isSelected ? '#5CA1D6' : 'rgba(110, 111, 112, 0.4)',
                'rgba(255, 255, 255, 0.4)',
            ];
        }
        return [
            toggleState.isSelected ? '#0074cc' : '#FFFFFF',
            toggleState.isSelected ? '#0074cc' : '#6E6F70',
            '#FFFFFF',
        ];
    };
    const [fillColor, strokeColor, itemColor] = getRectColors();
    const handleKeyDown = (e) => {
        if (e.key === ' ' && onChecked)
            onChecked();
    };
    const isMenu = variant === 'menu';
    const isMulti = variant === 'multiselect';
    return (_jsxs("div", { ...dataAttributes, className: "inline-flex p-1", children: [_jsx(VisuallyHidden, { children: _jsx("input", { ...inputProps, ...focusProps, ref: ref, onKeyDown: (e) => handleKeyDown(e) }) }), _jsxs("svg", { "aria-hidden": "true", className: buildClassName(isDisabled ? 'cursor-default' : 'cursor-pointer rounded-sm', {
                    'outline-primary-blue outline outline-2 outline-offset-1': isFocusVisible,
                }), height: 18, width: 18, viewBox: "0 0 18 18", onClick: (e) => {
                    e.stopPropagation();
                    if (!isDisabled && onChecked)
                        onChecked();
                }, "aria-label": "checkbox", children: [_jsx("rect", { className: buildClassName('hover:fill-primary-blue/10 hover:stroke-[rgb(80,100,117)]', {
                            'hover:fill-[rgb(74,146,206)] hover:stroke-[rgb(74,146,206)]': toggleState.isSelected === true,
                        }), fill: fillColor, stroke: strokeColor, strokeWidth: 1.5, height: 16.5, width: 16.5, x: 0.75, y: 0.75, rx: 2.25 }), toggleState.isSelected && isMulti && (_jsx("path", { d: "M3 9H15", stroke: itemColor, strokeWidth: "1.5", strokeLinecap: "round" })), toggleState.isSelected && isMenu && (_jsx("path", { d: "M13.6306 4.74035C13.9388 4.42501 14.4443 4.41921 14.7597 4.72741C15.0669 5.0277 15.0803 5.51528 14.7957 5.83179L14.7726 5.85642L7.54256 13.2541C7.23983 13.5639 6.74741 13.5746 6.4316 13.2842L6.40704 13.2607L3.23384 10.0875C2.92205 9.77567 2.92205 9.27016 3.23384 8.95837C3.53763 8.65458 4.02534 8.64679 4.33857 8.935L4.36293 8.95837L6.96496 11.5603L13.6306 4.74035Z", fill: itemColor }))] })] }));
};
export default Checkbox;
//# sourceMappingURL=Checkbox.js.map